import { useState, useCallback, useMemo, useRef } from 'react';
import type { TToast, TToastConfig, TToastContextValue } from './toast.types';

const useToastProvider = (): TToastContextValue => {
	const [toasts, setToasts] = useState<TToast[]>([]);
	const counterRef = useRef(0);

	const addToast = useCallback((config: TToastConfig) => {
		counterRef.current += 1;
		const id = `toast-${counterRef.current}`;
		setToasts((prev) => [...prev, { ...config, id }]);
		return id;
	}, []);

	const removeToast = useCallback((id: string) => {
		setToasts((prev) => prev.filter((t) => t.id !== id));
	}, []);

	return useMemo(
		() => ({ toasts, addToast, removeToast }),
		[toasts, addToast, removeToast]
	);
};

export { useToastProvider };
